import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import ManageProperties from './pages/ManageProperties';
import PropertyDetails from './pages/PropertyDetails';
import AddProperty from './pages/AddProperty';
import ManageUsers from './pages/ManageUsers';
import UserDetails from './pages/UserDetails';
import AddUser from './pages/AddUser';
import ManageSeller from './pages/ManageSeller';
import SellerDetails from './pages/SellerDetails';
import AddSeller from './pages/AddSeller';
import ManageAgencies from './pages/ManageAgencies';
import AgencyDetails from './pages/AgencyDetails';
import AddAgent from './pages/AddAgent';
import ActivityLog from './pages/ActivityLog';
import ActivityDetails from './pages/ActivityDetails';
import ManagePortfolios from './pages/ManagePortfolios';
import PortfolioDetails from './pages/PortfolioDetails';
import AddPortfolio from './pages/AddPortfolio';
import ReorderLandingPage from './pages/ReorderLandingPage';
import ManageEmailTemplates from './pages/ManageEmailTemplates';
import EmailTemplateDetails from './pages/EmailTemplateDetails';
import Login from './components/Login';
import { AuthProvider, useAuth } from './utils/AuthContext';
import { API_CONFIG } from './config/api';

// Create a separate component for the main app content
const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check if user is already authenticated from localStorage
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'var(--cbre-bg-primary)'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="properties" element={<ManageProperties />} />
          <Route path="properties/:id" element={<PropertyDetails />} />
          <Route path="add-property" element={<AddProperty />} />
          <Route path="reorder-landing-page" element={<ReorderLandingPage />} />
          <Route path="users" element={<ManageUsers />} />
          <Route path="users/:id" element={<UserDetails />} />
          <Route path="add-user" element={<AddUser />} />
          <Route path="sellers" element={<ManageSeller />} />
          <Route path="sellers/:id" element={<SellerDetails />} />
          <Route path="add-seller" element={<AddSeller />} />
          <Route path="agents" element={<ManageAgencies />} />
          <Route path="agencies/:id" element={<AgencyDetails />} />
          <Route path="add-agent" element={<AddAgent />} />
          <Route path="activity-log" element={<ActivityLog />} />
          <Route path="activity-log/:id" element={<ActivityDetails />} />
          <Route path="portfolios" element={<ManagePortfolios />} />
          <Route path="portfolios/:id" element={<PortfolioDetails />} />
          <Route path="add-portfolio" element={<AddPortfolio />} />
          <Route path="email-templates" element={<ManageEmailTemplates />} />
          <Route path="email-templates/:id" element={<EmailTemplateDetails />} />
        </Routes>
      </Layout>
    </Router>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;


